import React from 'react';

import './styles.scss';
import Loader from '../loader';
import {ISearchDialogue} from '../../redux/search/interfaces';
import {SearchCard} from '../search-card/SearchCard';

type Props = {
  cards: ISearchDialogue[];
  showLoader?: boolean;
  onLoadMore?: (count: number) => void;
  onClickCard: (dialogue: ISearchDialogue) => void;
  checkedCards?: number[];
  disabledButtons?: boolean;
}

export const SearchCardSection = ({
  showLoader = false,
  cards,
  onClickCard
}: Props): JSX.Element => {
  function handleClickCard(dialogue: ISearchDialogue) {
    return () => {
      onClickCard(dialogue);
    };
  }

  return <section className="search-card-section">
    {showLoader ? <Loader/> : <ul className="search-card-section__list">
      {
        cards && cards.length && cards.map((card, i) => {
          return <li key={card.dialogId} className="search-card-section__item">
            <SearchCard
              card={card}
              onClick={handleClickCard(card)}/>
          </li>;
        })
      }
    </ul>}
  </section>;
};
